/*
  Top Spinner — "Optional Lug Nuts: (Required)" enforcement (Basecamp todo 518808881).

  All wheel & tire SETS carry an "Optional Lug Nuts: (Required)" option whose first/default value is
  "Choose Option" (rendered as a native dropdown — see product-variant-picker.liquid ts_force_dropdown).
  Per Matt, the order must start on "Choose Option" so the customer makes a conscious lug-nut choice.
  This script:
    1) DEFAULT  — on load, force the selection to "Choose Option" (never silently default to "None"),
       and keep the fieldset/label text in sync.
    2) DISABLE  — while "Choose Option" is selected, the "Add to cart" button is disabled (greyed) and the
       express wallet buttons are hidden; they re-enable the moment None / Standard / Metric is chosen.
    3) BLOCK    — a submit/click safety net also prevents adding "Choose Option" and shows a message.

  Keys purely off the option name ("Optional Lug Nuts…") + the "Choose Option" value, so it only ever
  affects the wheel & tire sets. Covers the PDP and the quick-add modal (delegated + observed).
*/
(function () {
  var OPT_PREFIX = 'Optional Lug Nuts';
  var CHOOSE = 'Choose Option';
  var MESSAGE = 'Please choose a lug nut option.';

  function scopeFor(el) {
    return el.closest('product-info') || el.closest('quick-add-modal') || el.closest('.product') || document;
  }
  function lugRadios(scope) {
    return [].slice.call(scope.querySelectorAll('input[type="radio"][name*="' + OPT_PREFIX + '"]'));
  }
  function lugSelect(scope) {
    return scope.querySelector('select[name*="' + OPT_PREFIX + '"]');
  }
  function chooseRadio(scope) {
    return lugRadios(scope).filter(function (i) { return i.value === CHOOSE; })[0] || null;
  }
  function hasLug(scope) {
    return chooseRadio(scope) != null || lugSelect(scope) != null;
  }
  function selectedLug(scope) {
    var checked = scope.querySelector('input[type="radio"][name*="' + OPT_PREFIX + '"]:checked');
    if (checked) return checked.value;
    var sel = lugSelect(scope);
    if (sel) return sel.value;
    var span = scope.querySelector('.selected__value');
    return span ? span.textContent.trim() : null;
  }
  function isCartAddForm(form) {
    return (form.getAttribute('action') || '').indexOf('/cart/add') !== -1;
  }
  function syncLegend(scope, value) {
    scope.querySelectorAll('legend .selected__value').forEach(function (span) {
      var fs = span.closest('fieldset');
      if (fs && (fs.querySelector('input[name*="' + OPT_PREFIX + '"]') || fs.querySelector('select[name*="' + OPT_PREFIX + '"]'))) {
        span.textContent = value;
      }
    });
  }
  function addButtons(scope) {
    return [].slice.call(scope.querySelectorAll('.product-form__submit, button[name="add"]'));
  }

  function showError(host, message) {
    var wrapper = host && host.querySelector('.product-form__error-message-wrapper');
    var target = wrapper && wrapper.querySelector('.product-form__error-message');
    if (wrapper && target) {
      target.textContent = message;
      wrapper.removeAttribute('hidden');
      return;
    }
    window.alert(message);
  }

  // ---- DISABLE the buy buttons while "Choose Option" is selected -----------------------------------
  var PROMPT = 'Select an option';   // professional label while the placeholder is selected (never "Sold out")
  function btnLabel(btn) {
    // the visible text span in Dawn's add button (not the loading spinner)
    var spans = [].slice.call(btn.querySelectorAll('span'));
    for (var i = 0; i < spans.length; i++) {
      var c = spans[i].className || '';
      if (c.indexOf('spinner') === -1 && c.indexOf('loading') === -1) return spans[i];
    }
    return btn;
  }
  function updateBuyState(scope) {
    if (!hasLug(scope)) return;
    var block = selectedLug(scope) === CHOOSE;
    addButtons(scope).forEach(function (btn) {
      var t = btnLabel(btn);
      if (block) {
        btn.classList.add('ts-lug-disabled');
        btn.setAttribute('disabled', 'disabled'); btn.disabled = true; btn.setAttribute('aria-disabled', 'true');
        if (t && t.textContent.trim() !== PROMPT) t.textContent = PROMPT;   // replace "Sold out"/"Add to cart" with a prompt
      } else {
        if (btn.classList.contains('ts-lug-disabled')) {
          btn.classList.remove('ts-lug-disabled');
          btn.disabled = false; btn.removeAttribute('disabled'); btn.removeAttribute('aria-disabled');
        }
        if (t && t.textContent.trim() === PROMPT) t.textContent = 'Add to cart';  // a real option is chosen -> standard label
      }
    });
    scope.querySelectorAll('.shopify-payment-button, shopify-accelerated-checkout').forEach(function (w) {
      if (block) { if (w.getAttribute('data-ts-lug-hidden') == null) { w.setAttribute('data-ts-lug-hidden', '1'); w.style.display = 'none'; } }
      else if (w.getAttribute('data-ts-lug-hidden')) { w.removeAttribute('data-ts-lug-hidden'); w.style.display = ''; }
    });
    // suppress any "sold out / unavailable" badge that the theme paints from the placeholder variant
    scope.querySelectorAll('.badge, .product-badge, [class*="sold-out"], [class*="sold_out"], .price__badge-sold-out').forEach(function (bg) {
      if (/sold\s*out|unavailable/i.test(bg.textContent || '')) {
        if (block) { if (bg.getAttribute('data-ts-lug-badge') == null) { bg.setAttribute('data-ts-lug-badge', '1'); bg.style.display = 'none'; } }
        else if (bg.getAttribute('data-ts-lug-badge')) { bg.removeAttribute('data-ts-lug-badge'); bg.style.display = ''; }
      }
    });
  }

  // ---- DEFAULT: make "Choose Option" the starting selection ----------------------------------------
  function initScope(scope) {
    if (!hasLug(scope) || scope.__lugInit) return;
    scope.__lugInit = true;
    var cr = chooseRadio(scope);
    var sel = lugSelect(scope);
    if (cr) {
      // the placeholder variant reads as "unavailable" to the theme — present it as a clean, selectable choice
      cr.classList.remove('disabled'); cr.disabled = false;
      var lbl = scope.querySelector('label[for="' + cr.id + '"]');
      if (lbl) { lbl.classList.remove('disabled'); lbl.childNodes.forEach(function (nd) {
        if (nd.nodeType === 3 && /unavailable|sold out/i.test(nd.textContent)) nd.textContent = '';
      }); }
      if (!cr.checked) {
        lugRadios(scope).forEach(function (i) { i.checked = (i === cr); });
        cr.checked = true;
        cr.dispatchEvent(new Event('change', { bubbles: true }));
      }
    } else if (sel) {
      var idx = -1;
      for (var i = 0; i < sel.options.length; i++) {
        if (sel.options[i].value === CHOOSE) {
          sel.options[i].textContent = CHOOSE;           // strip a server-rendered " - Unavailable" suffix
          sel.options[i].disabled = false;
          sel.options[i].removeAttribute('disabled');
          idx = i;
        }
      }
      if (idx >= 0 && sel.selectedIndex !== idx) { sel.selectedIndex = idx; sel.dispatchEvent(new Event('change', { bubbles: true })); }
    }
    syncLegend(scope, CHOOSE);
    updateBuyState(scope);
  }
  function initAll() {
    document.querySelectorAll('product-info, quick-add-modal, .product').forEach(initScope);
    if (hasLug(document)) initScope(document);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  // ---- keep in sync as the user changes the option, and as the theme re-renders the buy buttons ----
  ['change', 'input'].forEach(function (evt) {
    document.addEventListener(evt, function (e) {
      var t = e.target;
      if (t && (t.name || '').indexOf(OPT_PREFIX) !== -1) {
        var scope = scopeFor(t);
        var val = selectedLug(scope);
        if (val) syncLegend(scope, val);
        // run now and again after the theme finishes swapping the buy buttons
        updateBuyState(scope);
        setTimeout(function () { updateBuyState(scope); }, 60);
        setTimeout(function () { updateBuyState(scope); }, 300);
      }
    });
  });

  // INP-friendly observer (19 Aug 2026): never query the whole document per mutation record.
  //  - added nodes: only look INSIDE the added subtree for a lug option (quick-add modal injecting its form)
  //  - other mutations: only re-sync scopes that were already initialised (scope.__lugInit) — pages
  //    without a lug option (most of the store) now cost ~0 per mutation instead of a full-document query
  //  - coalesce bursts into one rAF so a cart/drawer re-render triggers a single updateBuyState pass
  var pendingScopes = [];
  var flushQueued = false;
  function flushScopes() {
    flushQueued = false;
    var s = pendingScopes; pendingScopes = [];
    s.forEach(updateBuyState);
  }
  function queueScope(scope) {
    if (pendingScopes.indexOf(scope) === -1) pendingScopes.push(scope);
    if (!flushQueued) {
      flushQueued = true;
      (window.requestAnimationFrame || window.setTimeout)(flushScopes);
    }
  }
  var mo = new MutationObserver(function (muts) {
    var needInit = false;
    for (var i = 0; i < muts.length; i++) {
      var rec = muts[i];
      for (var j = 0; j < rec.addedNodes.length; j++) {
        var a = rec.addedNodes[j];
        if (a.nodeType === 1 && a.querySelector &&
            (a.querySelector('input[name*="' + OPT_PREFIX + '"]') || a.querySelector('select[name*="' + OPT_PREFIX + '"]'))) {
          needInit = true;
        }
      }
      var n = rec.target;
      if (n && n.nodeType === 1) {
        var scope = n.closest('product-info') || n.closest('quick-add-modal') || n.closest('.product') || document;
        if (scope.__lugInit) queueScope(scope);
      }
    }
    if (needInit) { initAll(); }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  // ---- BLOCK: safety net on submit / express click ------------------------------------------------
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || form.tagName !== 'FORM' || !isCartAddForm(form)) return;
    var scope = scopeFor(form);
    if (!hasLug(scope)) return;
    if (selectedLug(scope) === CHOOSE) {
      event.preventDefault();
      event.stopImmediatePropagation();
      showError(form.closest('product-form') || form.parentElement, MESSAGE);
      return false;
    }
  }, true);

  document.addEventListener('click', function (event) {
    var btn = event.target.closest &&
      event.target.closest('.shopify-payment-button, shopify-accelerated-checkout, .shopify-payment-button__button, .product-form__submit');
    if (!btn) return;
    var scope = scopeFor(btn);
    if (!hasLug(scope)) return;
    if (selectedLug(scope) === CHOOSE) {
      event.preventDefault();
      event.stopImmediatePropagation();
      var form = btn.closest('form');
      showError((form && form.closest('product-form')) || btn.closest('product-info') || btn.parentElement, MESSAGE);
    }
  }, true);
})();
